import { showToast } from './toast';

/**
 * Scroll a field into the visible area (e.g. shipping rate on validation).
 */
export function revealElement(el) {
  if (!el || typeof el.scrollIntoView !== 'function') return;
  try {
    el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
  } catch {
    el.scrollIntoView();
  }
}

/**
 * Validation feedback: toast only + optional scroll to related field.
 */
export function showFormError(message, options = {}) {
  const { target, type = 'warning' } = options;
  const el =
    typeof target === 'string'
      ? document.getElementById(target)
      : target || null;
  if (el) {
    revealElement(el);
  }
  showToast(message, type);
}
